import React, { FunctionComponent } from 'react'
import styles from './SearchPreview.module.sass'
import Color from '../../pickers/ColorPicker/Color'
import TagList from '../../tags/TagList/TagList'
import { SearchResult } from '../../../../responses/search'
import Image from '../../files/Image/Image'
import clsx from 'clsx'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import { Classes } from '../../../../styles'
import EmptyPreview from 'files/empty-preview.svg'
import ObjectName from '../../../etc/ObjectName/ObjectName'

interface Props {
    result: SearchResult
}

const gridStyle = (count: number) => {
    switch (count) {
        case 0:
        case 1:
            return styles.mode1
        case 2:
            return styles.mode2
        case 3:
        case 4:
            return styles.mode4
        case 5:
        case 6:
            return styles.mode6
        default:
            return styles.mode8

    }
}

export const SearchPreview: FunctionComponent<Props> = (props) => <ShadowContainer
    className={styles.container}
>
    <div className={clsx(styles.image, gridStyle(props.result.previews.length))}>
        {
            props.result.previews.length === 0 ? <div className={clsx(styles.item, styles.empty)}>
                <EmptyPreview/>
            </div>:
            props.result.previews.map(item => <Image
                key={item.id}
                className={styles.item}
                file={item}
                objectFit={'scale-down'}
            />)
        }
    </div>
    <div className={styles.info}>
        <ObjectName className={styles.name} object={props.result.project_work_object}/>
        <div className={clsx(styles.date, Classes.cGrey, Classes.f9)}>{props.result.project.opened_at}</div>
        <Color className={styles.tag}>{props.result.type.short_name}</Color>
        <TagList reverse className={styles.tags} tags={props.result.project_work_object.tags}/>
    </div>
</ShadowContainer>